module.exports = __webpack_public_path__ + "static/media/six-pots.b09d459f.jpg";